import { IconButton, styled } from "@patientmpower/spiro";

export const PatientMenuCardContainer = styled("div", {
  width: "100%",
  height: 80,

  padding: "16px 22px 16px 28px",

  borderBottom: "1px solid $gray-40",

  fontFamily: "$openSans",

  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",

  "&[dragging='true']": {
    backgroundColor: "$gray-60",
    opacity: "0.7",
  },

  variants: {
    isVisible: {
      true: {
        backgroundColor: "$white",
      },
      false: {
        backgroundColor: "$gray-30",
      },
    },
  },
});

export const PatientMenuCardContent = styled("div", {
  width: "100%",
  cursor: "auto",

  p: {
    color: "$gray-90",
    paddingLeft: 8,

    fontSize: "$text-md",

    span: {
      fontWeight: 600,
    },
  },

  button: {
    width: "100%",
    marginTop: 4,
    padding: "3px 8px 4px",

    fontSize: "$text-md",

    fontFamily: "$openSans",

    textAlign: "left",

    border: "2px solid transparent",
    borderRadius: 6,

    boxSizing: "border-box",

    color: "$gray-90",
    backgroundColor: "transparent",

    "&:focus-visible": {
      outline: "none !important",
      border: "2px solid $primary-30",
    },

    "&:focus": {
      outline: "none !important",
    },

    "&:hover": {
      cursor: "auto",
      // backgroundColor: "$primary-20",
    },
  },
});

export const PatientMenuCardControls = styled("div", {
  display: "flex",
  alignItems: "center",

  columnGap: "$8",
});

export const GrabButton = styled("button", {
  cursor: "grab",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  border: "none",
  borderRadius: "50%",
  backgroundColor: "transparent",

  width: 28,
  height: 28,
  padding: 8,

  "&:active": {
    cursor: "grabbing",
  },
});

export const VisibilityButton = styled(IconButton, {
  variants: {
    isActive: {
      true: {
        backgroundColor: "$gray-60",
      },
      false: {
        backgroundColor: "$success-light",

        "&:hover": {
          backgroundColor: "$success-light",
          opacity: 0.6,
        },
      },
    },
  },
});
